import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ********************* START GET SAVINGS FOLLOWUP REPORT DETAILS ******************** */
export const savingsFollowupReportGet = (reportData: any) => {
	const data = {
		GetSavingsFollowupReportKeyToken: reportData,
	};
	const url = `${API_URL}getAllSavingsFollowUp`;
	return makeApiCall(url, data);
};
/** ********************* END GET SAVINGS FOLLOWUP REPORT DETAILS ******************** */
